import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import convertToOvariant from '../../utils/convertToOvariant';
import api from '../../services/api';
import useTranslate from '../../customHooks/useTranslate';
import { savableEntities } from '../../utils/commonVariables/entityKeys';
import { publicEndpoints } from '../../utils/commonVariables/endpoints';
import { Card, CardActions, CardContent } from '@mui/material';
import conejoLogin from '../../images/conejito.svg';
import TextInput from '../../muiComponents/TextInput/TextInput';
import Button from '../../muiComponents/Button';
import { validateForm } from '../../utils/validateForms';
import routes from '../../utils/commonVariables/routes';

export default function FormForgotPassword() {
    const [userNameOrEmail, setUserNameOrEmail] = useState('');
    const [validated, setValidated] = useState(false);
    const [errorDDBB, setErrorDDBB] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [emailRequestSubmitted, setEmailRequestSubmitted] = useState(false);
    const forgotPasswordText = useTranslate('forgot_password_text');
    const sendEmailText = useTranslate('sended_email');
    const somethingWrongText = useTranslate('something_went_wrong');
    const requestPasswordChangeText = useTranslate('request_password_change');
    const returnToLoginText = useTranslate('return_to_login');

    const handleChangeInput = event => {
        const { value } = event.currentTarget;
        setUserNameOrEmail(value);
    };

    const handleBlur = () => {
        if (validated) {
            handleValidate();
        }
    };

    const fieldsToValidate = {
        UserNameOrEmail: {
            value: userNameOrEmail,
            validators: ['requiredString'],
        },
    };

    const handleValidate = () => {
        const formErrors = validateForm(fieldsToValidate);
        setValidationErrors(formErrors);
        return !formErrors.length;
    };

    const handleSubmit = async () => {
        try {
            setValidated(true);
            const isValid = handleValidate();
            if (!isValid) {
                return;
            }
            setValidationErrors([]);
            const emailToSend = { Email: userNameOrEmail };
            const objectToSend = convertToOvariant(
                savableEntities.SystemUser,
                emailToSend
            );

            const endpoint = publicEndpoints.forgotPassword;
            const res = await api.post(endpoint, objectToSend);
            if (res.status === 200) {
                setEmailRequestSubmitted(true);
            } else {
                setErrorDDBB(true);
            }
        } catch (error) {
            console.log(error);
            setErrorDDBB(true);
        }
    };

    return (
        <main className='main__login'>
            <div className='flex-column flex-center flex-align-center'>
                <Card
                    className='flex-column gap-10'
                    sx={{
                        width: 380,
                        padding: '40px 50px',
                    }}
                >
                    <CardContent className='padding0 gap-20 flex-column flex-center flex-align-center'>
                        {emailRequestSubmitted ? (
                            <p className='text-align-center'>{sendEmailText}</p>
                        ) : (
                            <>
                                <img
                                    alt={'Fast pay hotel logo'}
                                    src={conejoLogin}
                                    height={120}
                                />
                                <p className='text-align-center'>
                                    {forgotPasswordText}
                                </p>
                                <TextInput
                                    type='text'
                                    required
                                    labelText='user_name_or_email_address'
                                    handleChange={e => handleChangeInput(e)}
                                    onBlur={handleBlur}
                                    name='email'
                                    errorMessage={
                                        validated &&
                                        validationErrors.length &&
                                        validationErrors?.[0]?.errorMessage
                                    }
                                />
                            </>
                        )}
                    </CardContent>
                    <CardActions className='flex-column flex-center flex-align-center gap-10'>
                        {emailRequestSubmitted ? (
                            <Button
                                component={Link}
                                to={routes.login}
                                variant='contained'
                            >
                                {returnToLoginText}
                            </Button>
                        ) : (
                            <>
                                <Button
                                    variant='contained'
                                    className='button-submit'
                                    onClick={handleSubmit}
                                >
                                    {requestPasswordChangeText}
                                </Button>
                                {errorDDBB && (
                                    <div className='text-align-center'>
                                        <p className='text-error-color'>
                                            {somethingWrongText}
                                        </p>
                                    </div>
                                )}
                            </>
                        )}
                    </CardActions>
                </Card>
            </div>
        </main>
    );
}
